import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router'
import { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import ErrorFallback from '~containers/general/error'
import Loading from '~containers/general/loading'
import SamsungSmartThingsPortal from '~containers/samsung.smart-things/portal'
import useLogInStatus from '~hooks/use-login-status'
import { useAppReset } from '~store/reset'

export const Route = createFileRoute('/samsung/smart-things/(app)')({
  component: RouteComponent,
})

function RouteComponent() {
  const isLoggedIn = useLogInStatus()
  // 앱이 초기화되는 중이었는 지 확인 (브라우저 라우터 이슈 때문에 추가)
  const hasAppReset = useAppReset()

  if (!isLoggedIn) {
    return <Navigate to="/samsung/smart-things/login" replace />
  }

  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary onReset={reset} FallbackComponent={ErrorFallback}>
          <Suspense fallback={<Loading />}>
            {hasAppReset ? <SamsungSmartThingsPortal /> : <Outlet />}
          </Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  )
}
